export default process.env.REACT_APP_NODE_ENV === "development"
    ? "http://localhost:5050"
    : process.env.REACT_APP_NODE_ENV === "production"
    ? "https://server.rscitrasundari.com"
    : "https://rscs-online-back-production.up.railway.app";
